import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { API_URL as API } from '../utils/apiUrl';

const SESSION_KEY = 'gw_sid';

const getSessionId = () => {
  let sid = sessionStorage.getItem(SESSION_KEY);
  if (!sid) {
    sid = typeof crypto.randomUUID === 'function'
      ? crypto.randomUUID()
      : Math.random().toString(36).slice(2) + Date.now().toString(36);
    sessionStorage.setItem(SESSION_KEY, sid);
  }
  return sid;
};

const getDeviceType = () => {
  const w = window.innerWidth;
  if (w < 768) return 'mobile';
  if (w < 1024) return 'tablet';
  return 'desktop';
};

const getUtm = () => {
  const p = new URLSearchParams(window.location.search);
  return {
    utm_source:   p.get('utm_source')   || null,
    utm_medium:   p.get('utm_medium')   || null,
    utm_campaign: p.get('utm_campaign') || null,
  };
};

const sendBeacon = (url, data) => {
  const payload = JSON.stringify(data);
  if (navigator.sendBeacon) {
    navigator.sendBeacon(url, new Blob([payload], { type: 'application/json' }));
  } else {
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: payload,
      keepalive: true,
    }).catch(() => {});
  }
};

// Export for business events tracking in any component
export const trackEvent = (eventType, properties = {}) => {
  if (/bot|crawler|spider|prerender/i.test(navigator.userAgent)) return;
  const sid = sessionStorage.getItem(SESSION_KEY);
  if (!sid) return;
  sendBeacon(`${API}/event`, { session_id: sid, event_type: eventType, properties });
};

export function usePageTracking() {
  const { pathname } = useLocation();
  const referrerRef  = useRef(document.referrer || '');
  const heartbeatRef = useRef(null);

  // Track each SPA navigation
  useEffect(() => {
    if (/bot|crawler|spider|prerender/i.test(navigator.userAgent)) return;

    const sid = getSessionId();
    sendBeacon(`${API}/track`, {
      session_id:  sid,
      page:        pathname,
      referrer:    referrerRef.current,
      device_type: getDeviceType(),
      ...getUtm(),
    });

    referrerRef.current = '';
  }, [pathname]);

  // Heartbeat every 30s to maintain "active now" count
  useEffect(() => {
    if (/bot|crawler|spider|prerender/i.test(navigator.userAgent)) return;

    const ping = () => {
      // « Actif maintenant » ne compte QUE les onglets réellement visibles : un onglet laissé
      // en arrière-plan des heures/jours ne doit pas continuer à émettre de battement (comme les
      // meilleurs sites → mesure d'audience juste + zéro requête inutile sur une page au repos).
      if (typeof document !== 'undefined' && document.visibilityState !== 'visible') return;
      const sid = sessionStorage.getItem(SESSION_KEY);
      if (sid) sendBeacon(`${API}/ping`, { session_id: sid });
    };

    heartbeatRef.current = setInterval(ping, 30_000);
    return () => clearInterval(heartbeatRef.current);
  }, []);
}
